import { ReactComponent as LightIconSVG } from '../../assets/icons/mevo/ic_light.svg';
import IconPattern, { IconProps } from './_IconPattern';

const LightIcon: React.FC<IconProps> = (props) => {
  return <IconPattern component={LightIconSVG} variantPlaces={[]} {...props} />;
};

export default LightIcon;
